/**
 * The app's route paths, in one place.
 *
 * `*_SEGMENT` is what `main.tsx` mounts (relative, as react-router wants it) and
 * `*_PATH` is the absolute form used to navigate and to detect the current mode.
 * Deriving one from the other is the point: changing the route can't leave a
 * `<Navigate>` or a mode check pointing at a path that no longer exists.
 */
export const DASHBOARDS_SEGMENT = 'dashboards';
export const DASHBOARDS_PATH = `/${DASHBOARDS_SEGMENT}`;

/** Conversation mode — the app's index route. */
export const CONVERSATION_PATH = '/';
